import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from 'src/app/session-service.service';
import { BaseComponent } from '../BaseComponent';

@Component({
  selector: 'app-area-input',
  templateUrl: 'area-input.html',
  styleUrls: ['area-input.css'],
  encapsulation: ViewEncapsulation.None
})
export class AreaInputComponent extends BaseComponent implements OnInit {
  @Input()
  hint: string;

  @Input()
  maxlength: number;

  @Input()
  matAutosizeMinRows = 3;

  @Input()
  matAutosizeMaxRows = 5;

  @Input()
  maxCharacters: number;

  controlType = this.constructor.name;

  constructor(translateService: TranslateService, sessionService: SessionService) {
    super(translateService, sessionService);
  }
}
